import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ChillerDetail from '../../components/ac_central/ChillerDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import {
  getChiller,
  createChiller,
} from '../../redux/ac_central/chiller_actions';

class ACCentralCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ac !== nextProps.ac && nextProps.show) {
      this.props.getChiller(nextProps.ac.id);
    }
  }

  onSaveHandler() {
    const newChiller = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.createChiller(newChiller);
  }

  render() {
    const { isCreating, errorMessage, acDetail, t, getChiller, createChiller, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create chiller')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChillerDetail
            ac={acDetail}
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-chiller-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.chiller.errorMessage,
  isCreating: state.ac.chiller.isCreating,
  acDetail: props.ac && state.ac.chiller.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  createChiller: ac =>
    defaultRejectHandler(
      dispatch(
        createChiller(
          ac.name,
          ac.type,
          ac.brand_id,
          ac.compressor_type || 'na',
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
        ),
      ),
    ),
  getChiller: id => defaultRejectHandler(dispatch(getChiller(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACCentralCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/ChillerCreateModal.js